// extracted by mini-css-extract-plugin
export default {"flex_container":"HistoryPageSite_flex_container__UXqzV","text":"HistoryPageSite_text__ChRKd","img":"HistoryPageSite_img__KKNw4","imgList":"HistoryPageSite_imgList__zjH9r"};